import state from "@/store/modules/products/productsState";
import getters from "@/store/modules/products/productsGetters";
import mutations from "@/store/modules/products/productsMutations";
import actions from "@/store/modules/products/productsActions";

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}